

















































































import Vue from "vue";
import Component from "vue-class-component";
import {State} from "vuex-class";
import Category from "@/modules/support/model/Category";
import {Prop} from "vue-property-decorator";
import {notify} from "@/modules/core/notification";
import ConfirmDeleteCategory from "@/modules/support/components/Guide/ConfirmDeleteCategory.vue";

/**
 * Árbol de categorías
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    name: 'CategoryTree',
    components: {ConfirmDeleteCategory}
})
export default class CategoryTree extends Vue {
    /**
     * Categoría raíz del sistema de guías de soporte
     */
    @State(state => state.support.rootCategory)
    rootCategory: Category

    /**
     * Categoría actualmente seleccionada por el usuario
     */
    @State(state => state.support.currentCategory)
    currentCategory: Category | null

    @Prop({type: Boolean, default: false})
    public hideActions: boolean

    @Prop({type: Boolean, default: true})
    public activatable: boolean

    @Prop({type: Array, default: () => []})
    public active: Category[]

    /**
     * Lista de categorías que no serán mostradas en el arbol
     */
    @Prop({type: Array, default: () => []})
    public exclude: Category[]

    /**
     * Selección multiple
     *
     * Al seleccionar esta opción el usuario podrá seleccionar multiples
     * nodos del árbol de categorías
     */
    @Prop({type: Boolean, default: false})
    public multiple: boolean

    /**
     * Lista de categorías abiertas
     */
    public opened: Category[] = []

    public selectParent = false
    public changingParent = false
    public deleteConfirm = false

    /**
     * Almacena la categoría la cual cambiará de padre
     */
    public toChangeParent: Category | null = null

    /**
     * Cambia el padre de una categoría
     */
    public async changeParent (parent: Category) {
        this.selectParent = false
        this.changingParent = true

        await this.$store.dispatch('support/changeCategoryParent', {
            newParent: parent.id,
            category: this.toChangeParent,
        })

        this.changingParent = false
        notify(`La categoría ${this.toChangeParent?.name} ha sido movida`)
    }

    public get tree() {
        return [this.convertCategory(this.rootCategory)]
    }

    public async createCategory(parent: Category) {
        this.opened.push(parent)
        await this.$store.dispatch('support/createCategory', parent.id)
    }

    public convertCategory(category: Category): any {
        return {
            id: category.id,
            name: category.name,
            children: category.children
                .filter(c => !this.isExcluded(c))
                .map(c => this.convertCategory(c)),
            entity: category,
        }
    }

    /**
     * Indica si la categoría argumentada se encuentra excluida
     */
    public isExcluded(category: Category) {
        return !!this.exclude.find(e => e.id === category.id)
    }

    /**
     * Abre el díálogo para confirmar la eliminación de categorías
     *
     * @param category
     */
    public openDeleteConfirm (category: Category) {
        this.$store.commit('support/SET_CURRENT_CATEGORY', category)
        this.deleteConfirm = true
    }
}
